import { render, staticRenderFns } from "./Tarifvergleich.vue?vue&type=template&id=368137c0&"
import script from "./Tarifvergleich.vue?vue&type=script&lang=js&"
export * from "./Tarifvergleich.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports